import en from './en'
import de from './de'

export const resources = {
  en: { translation: en },
  de: { translation: de },
}

export const supportedLanguages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
]